import React, { useContext, useState, useEffect } from "react";
import "./style.scss";
import { useHistory } from "react-router-dom";

import Person from "@material-ui/icons/Person";
import Email from "@material-ui/icons/Email";
import Lock from "@material-ui/icons/Lock";
import SchoolRounded from "@material-ui/icons/SchoolRounded";
import MenuBookRounded from "@material-ui/icons/MenuBookRounded";

import { AuthContext } from "../../context/authContext/AuthContext";
import { registerUser } from "../../context/authContext/apiCalls";
import axios from "axios";
import { Snackbar, Alert } from "@mui/material";

const Register = () => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [course, setCourse] = useState("");
  const [semester, setSemester] = useState("");
  const [isTeacher, setIsTeacher] = useState(false);

  const { isFetching, dispatch, error, user } = useContext(AuthContext);
  const history = useHistory();

  const [toast, setToast] = useState({ open: false, msg: "", severity: "info" });
  const openToast = (msg, severity = "info") => setToast({ open: true, msg, severity });
  const closeToast = () => setToast((t) => ({ ...t, open: false }));
  const [registrationOpen, setRegistrationOpen] = useState(true);

  const handleRegister = () => {
    if (!registrationOpen) {
      openToast("Registration is currently closed. If your account is active, please login or contact your teacher.", "error");
      return;
    }
    if (!(fullname && email && password && course && semester)) {
      openToast("Please fill all fields", "error");
    } else if (password !== confirmPass) {
      openToast("Passwords do not match", "error");
    } else {
      registerUser(
        { fullname, email, password, course, semester, isTeacher },
        dispatch
      );
    }
  };

  useEffect(() => {
    if (user && !isFetching) {
      openToast("Registration Successful", "success");
    }
  }, [user, isFetching]);

  useEffect(() => {
    if (error && !isFetching) {
      const status = error?.response?.status;
      const data = error?.response?.data;
      if (status === 403 && (data?.code === "REGISTRATION_CLOSED")) {
        setRegistrationOpen(false);
        openToast("Registration is currently closed. If your account is active, please login or contact your teacher.", "error");
        return;
      }
      const message = typeof data === "string" ? data.toLowerCase() : "";
      if (status === 409 || message.includes("duplicate") || (data?.code === 11000)) {
        openToast("Email already exists", "error");
      } else if (message.includes("validation") || status === 400) {
        openToast("Invalid details", "error");
      } else {
        openToast("Registration failed. Please try again.", "error");
      }
    }
  }, [error, isFetching]);

  // Load config on mount to reflect registration status
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await axios.get("/api/config/registration");
        setRegistrationOpen(!!res.data?.registrationOpen);
        if (!res.data?.registrationOpen) {
          openToast("Registration is currently closed. If your account is active, please login or contact your teacher.", "error");
        }
      } catch (_) {}
    };
    loadConfig();
  }, []);

  return (
    <div className="register">
      <div className="card">
        <div className="card2">
          <form className="form" onSubmit={(e)=> e.preventDefault()}>
            <p id="heading">Register</p>

            <div className="field">
              <Person className="input-icon" />
              <input
                type="text"
                className="input-field"
                name="fullname"
                value={fullname}
                placeholder="Enter full name"
                onChange={(e) => setFullname(e.target.value)}
              />
            </div>

            <div className="field">
              <SchoolRounded className="input-icon" />
              <select
                name="course"
                value={course}
                onChange={(e) => setCourse(e.target.value)}
                className="input-field"
              >
                <option value="">Select Course</option>
                <option value="BCA">BCA</option>
                <option value="BTech">B.Tech.</option>
                <option value="MBA">MBA</option>
              </select>
            </div>

            <div className="field">
              <MenuBookRounded className="input-icon" />
              <input
                type="text"
                className="input-field"
                name="semester"
                value={semester}
                placeholder="Your semester"
                onChange={(e) => setSemester(e.target.value)}
              />
            </div>

            <div className="field">
              <Email className="input-icon" />
              <input
                type="text"
                className="input-field"
                name="email"
                value={email}
                placeholder="Your email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="field">
              <Lock className="input-icon" />
              <input
                type="password"
                className="input-field"
                name="password"
                value={password}
                placeholder="Enter Password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="field">
              <Lock className="input-icon" />
              <input
                type="password"
                className="input-field"
                name="confirmPassword"
                value={confirmPass}
                placeholder="Confirm Password"
                onChange={(e) => setConfirmPass(e.target.value)}
              />
            </div>

            <div className="btn">
              <button type="button" className="button1" onClick={handleRegister} disabled={isFetching}>
                Register
              </button>
              <button type="button" className="button2" onClick={() => history.push("/login")}>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>

      <Snackbar
        open={toast.open}
        autoHideDuration={2500}
        onClose={closeToast}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={closeToast} severity={toast.severity} variant="filled" sx={{ bgcolor: toast.severity === 'success' ? 'primary.main' : undefined }}>
          {toast.msg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Register;
